export default __webpack_public_path__ + "static/analysts_Logician_INTP_parenthood-f7b7320c1138990bb89b4dbd60176a0d.svg";